module.exports = __webpack_public_path__ + "img/r_figure_06.208c7acb.png";